
import { Routes, Route } from "react-router-dom";
import './style/main.scss';

import Home from './pages/Home';
import Login from "./pages/Login";
import RegisterOrg from "./pages/RegisterOrg";
import WIP from './pages/WIP';

//Fram Activity
import Traceability from "./pages/farmActivity/Traceability";
import Meeting from "./pages/farmActivity/Meeting";
import Training from "./pages/farmActivity/Training";
import Distribution from "./pages/farmActivity/Distribution";

//Livestock
import LivestockCount from "./pages/livestock/LivestockCount";
import LivestockActivity from "./pages/livestock/LivestockActivity";
import LivestockAlert from "./pages/livestock/LivestockAlert";

//Advisory
import InputCategory from './pages/advisory/InputCategory';

//Master
import Farmer from "./pages/master/Farmer";
import Pg_Vo from "./pages/master/Pg_Vo";
import Employee from "./pages/master/Employee";
import UserManagement from "./pages/master/UserManagement";
import CropMaster from "./pages/master/CropMaster";
import CropVariety from "./pages/master/CropVariety";
import EventTopic from "./pages/master/EventTopicMaster";
import EventSubject from "./pages/master/EventSubjectMaster";
import DemographyMaster from "./pages/master/DemographyMaster";
import CropMasterList from "./pages/master/CropMasterList";

//Report

//Setting
import Profile from "./pages/setting/Profile";
import Uom from "./pages/setting/Uom";
import Language from "./pages/setting/Language";
import Organisation from "./pages/setting/Oraganization";
import PackageOfPractice from "./pages/setting/PackageOfPractice";
import Demand from "./pages/setting/Demand";
import InputSalePurchase from "./pages/setting/InputSalePurchase";
import ProduceSalePurchase from "./pages/setting/ProduceSalePurchase";

//Report
import FarmerSowingReport from "./pages/report/FarmerSowingReport";
import MonthlyLivestockReport from "./pages/report/MonthlyLivestockReport";
import MonthlyAgricultureReport from "./pages/report/MonthlyAgricultureReport";
import LivestockReport from './pages/report/LivestockReport';
import AgricultureReport from './pages/report/AgricultureReport';

function App() {
  return (
    <div className="App" style={{marginTop: "70px"}}>
      <Routes>
        <Route path="/" element={ <Login /> } />
        <Route path="/register" element={ <RegisterOrg /> } />
        <Route path="/home" element={ <Home /> } />
        
        <Route path="/traceability" element={ <Traceability /> } />
        <Route path="/meeting" element={ <Meeting /> } />
        <Route path="/training" element={ <Training /> } />
        <Route path="/distribution" element={ <Distribution /> } />

        <Route path="/livestock-count" element={ <LivestockCount /> } />
        <Route path="/livestock-activity" element={ <LivestockActivity /> } />
        <Route path="/livestock-alert" element={ <LivestockAlert /> } />
        
        <Route path="/input" element={ <InputCategory /> } />

        <Route path="/farmer" element={ <Farmer /> } />
        <Route path="/pg" element={ <Pg_Vo /> } />
        <Route path="/employee" element={ <Employee /> } />
        <Route path="/user-management" element={ <UserManagement /> } />
        <Route path="/crop-master" element={ <CropMaster /> } />
        <Route path="/crop-variety" element={ <CropVariety /> } />
        <Route path="/event-topic" element={ <EventTopic /> } />
        <Route path="/event-subject" element={ <EventSubject /> } />
        <Route path="/demography-master" element={ <DemographyMaster /> } />
        <Route path="/crop-master-list" element={ <CropMasterList /> } />
        <Route path="/profile" element={ <Profile /> } />
        <Route path="/uom" element={ <Uom /> } />
        <Route path="/languages" element={ <Language /> } />
        <Route path="/Organisation" element={ <Organisation /> } />
        <Route path="/pop" element={ <PackageOfPractice /> } />
        <Route path="/demand" element={ <Demand /> } />
        <Route path="/input-sale-purchase" element={ <InputSalePurchase /> } />
        <Route path="/produce-sale-purchase" element={ <ProduceSalePurchase /> } />

        <Route path="/farmer-sowing-report" element={ <FarmerSowingReport /> } />
        <Route path="/monthly-livestock-report" element={ <MonthlyLivestockReport /> } />
        <Route path="/monthly-agriculture-report" element={ <MonthlyAgricultureReport /> } />
        <Route path="/reports/livestock" element={<LivestockReport />} />
        <Route path="/reports/agriculture" element={<AgricultureReport />} />

        <Route path="*" element={ <WIP /> } />
      </Routes>

      {/* <Header /> */}
      {/* <Page title='TestingPage' breadcrumbs='hello' children='hello-children' /> */}
    </div>
  );
}

export default App;